import { useRuntimeConfig } from '#app';
export default function (path: string): string {
  const config = useRuntimeConfig();
  return `${config.public.kenticoMedia}${path}`;
}
